// jshint maxparams:200
import SearchResultFilterBoxUI from 'static/script/app/ui/search-result/search-result-filter-box-ui';
import FormSelectUI from 'static/script/app/ui/form-select-ui';
import SearchResultHeaderUI from 'static/script/app/ui/search-result/search-result-header-ui';
import SearchResultFilterCloseUI from 'static/script/app/ui/search-result/search-result-filter-close-ui';
import Expandable from 'static/script/app/ui/expandable';
import ResultLayoutTogglerUI from 'static/script/app/ui/search-result/result-layout-toggler-ui';
import Pagination from 'static/script/app/ui/search-result/pagination';
import WishListUIList from 'static/script/app/ui/wish-list-ui-for-list';
import ItemCardsUI from 'static/script/app/ui/item-cards-ui';
import ItemsInViewportUI from 'static/script/app/ui/items-in-viewport-ui';
import FilterButtonsUI from 'static/script/app/ui/search-result/filter-buttons-ui';
import ScrollToTopUI from 'static/script/app/ui/search-result/scroll-to-top-ui';
import ShowAllFiltersUI from 'static/script/app/ui/search-result/show-all-filters-ui';
import Realtime from 'static/script/app/ui/realtime';
import SaveSearchUI from 'static/script/app/ui/save-search-ui';
import SaveSearchService from 'static/script/app/data/saved-searches-service';

export default (initData, teardownAll) => {
    if (teardownAll === true) {
        // When filtering on mobile and replacing the result html we need
        // to manually teardown those components to avoid memory leak
        SearchResultFilterBoxUI.teardownAll();
        FormSelectUI.teardownAll();
        SearchResultHeaderUI.teardownAll();
        SearchResultFilterCloseUI.teardownAll();
        Expandable.teardownAll();
        ResultLayoutTogglerUI.teardownAll();
        Pagination.teardownAll();
        WishListUIList.teardownAll();
        ItemCardsUI.teardownAll();
        ItemsInViewportUI.teardownAll();
        FilterButtonsUI.teardownAll();
        ScrollToTopUI.teardownAll();
        ShowAllFiltersUI.teardownAll();
        Realtime.teardownAll();
        SaveSearchService.teardownAll();
        SaveSearchUI.teardownAll();
    }

    SearchResultFilterBoxUI.attachTo('[data-search-filter-box]');
    SearchResultHeaderUI.attachTo('.search-result-header');
    FormSelectUI.attachTo('[data-form-select]');
    Expandable.attachTo('[data-expandable]');
    ResultLayoutTogglerUI.attachTo('[data-search-result-toggler]');
    Pagination.attachTo('[data-pagination]');
    WishListUIList.attachTo('[data-card-list-container]', {
        initData: initData
    });
    WishListUIList.attachTo('[data-card-list-container-ondisplay]', {
        initData: initData
    });
    ItemCardsUI.attachTo('[data-card-list-container]');
    SearchResultFilterCloseUI.attachTo('[data-button-filter-close]');

    FilterButtonsUI.attachTo('[data-search-result-header]');
    ScrollToTopUI.attachTo('[data-scroll-to-top]');
    ShowAllFiltersUI.attachTo('[data-search-tags-box]');
    Realtime.attachTo('[data-card-list-container]', { initData: initData });
    SaveSearchService.attachTo(document);
    SaveSearchUI.attachTo('[data-save-search-container]', {
        initData: initData
    });
};
